import styled from 'styled-components'

const SignatureImage = styled.img`
  width: 270px;
  height: 115px;
`

export default SignatureImage
